import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const CoverageDetailsTriggerStyle: StyleExtend<Theme> = {
  color: (theme) => theme.palette.customColors.gunMetal,
  textDecoration: 'underline',
  textUnderlineOffset: '.35em !important',
  textDecorationStyle: 'dotted',
  width: 'fit-content',
  userSelect: 'none',
};
